import { Pipe, PipeTransform } from '@angular/core';
import { ConversationNormalizedMessageStatus } from 'common/store/genesys-cloud/conversations/messages/models/message-data.model';

@Pipe({
  name: 'appChatMessageStatusTranslationKey'
})
export class ChatMessageStatusTranslationKeyPipe implements PipeTransform {
  transform(messageStatus: ConversationNormalizedMessageStatus): string {
    switch (messageStatus) {
      case 'Sent':
        return 'gcChatMessageList.Sent';
      case 'Published':
        return 'gcChatMessageList.Published';
      case 'Delivered':
        return 'gcChatMessageList.Delivered';
      case 'Read':
        return 'gcChatMessageList.Read';
      case 'Failed':
        return 'gcChatMessageList.Failed';
      case 'Removed':
        return 'gcChatMessageList.Removed';
      default:
        return '';
    }
  }
}
